import services from './../../../services/service'; // Service Class

let service = new services();
// import ProductForm from '../../../components/product/ProductForm.vue'
// import ProductItemForm from '../../../components/product/ProductItemForm.vue'
// import ProductCartActions from '../../../components/product/ProductCartActions.vue'

//let service = new services();

import {
  ADD_TO_CART,
  REMOVE_FROM_CART
} from '../../../store/mutation-types'
export default {
    name: 'Cart',
    data () {
        return {
          loading:false,
          user: {},
          group_products:{},
          item_product:{},
          checked_out: [],
          processed_checkout_orders: [],
          sorted_cart: [],
          orders: [],
          cart: this.$store.state.cart,
          img_product_url: service.imageProductsURL,
          coupon_code:[],
          product_delivery_fee: "",
          sellpoint_delivery_fee: "",
          payment_option: "",
          total_order_amt: 0.0,
          total_delivery_fee: 0.0,
          processed_groups:0,
          process_count:0,
          loggedIn:false,
          buy_now_order:false,
        }
      },
    components: {
       
      },
    computed: {
        // a computed getter
        // totalDeliveryFee: function () {
        //     this.sorted_cart.forEach(function(element) {
        //         console.log(element['delivery_option_fee'])
        //         /////this.total_delivery_fee += element['delivery_option_fee']
        //         return element['delivery_option_fee']
        //     });
        // }
    },
    methods:{
        setComponent(attr1,attr2){
           
            
        },

        toggleProductDelivery(attr1,i,product_index){
            if(attr1 == 'item-delivery-options'){
                this.sorted_cart[i][1][product_index].display_delivery_details = true;
            }
            if(attr1 == 'hide-item-delivery-options'){
                this.sorted_cart[i][1][product_index].display_delivery_details = false;
            }
        },

        toggleSellpointDelivery(attr1,i){
            if(attr1 == 'group-delivery-options'){
                this.sorted_cart[i].display_delivery_details++;
            }
            if(attr1 == 'hide-group-delivery-options'){
                this.sorted_cart[i].display_delivery_details = false;
            }
        },

        removeFromCart (item_id,group_index,item) {
            this.removeFromSortedCart(group_index,item);
            this.$store.commit(REMOVE_FROM_CART, item_id);

            //new
            this.prepCart(); //refresh hack
        },

        removeFromSortedCart(group_index,item){
            const index = this.sorted_cart[group_index][1].findIndex(p => p._id === item._id) //best removal
            this.sorted_cart[group_index][1].splice(index, 1);
        },

       
        prepCart(){
            //sort min cart into sorted carts
            let sorted_cart = Object.values(this.cart.reduce((result, obj) => {
                (result[obj.product_business] || (result[obj.product_business] = [])).push(obj);
                return result;
            }, {}));
            //../sort min cart into sorted carts

            let count = 0; let sorted_cart_array = []
            sorted_cart.forEach(function(element) {
                let pre_sort = [];

                //some watchers
                pre_sort.products_with_delivery_details_count = 0;
                pre_sort.products_without_delivery_details_count = 0;
                pre_sort.products_with_delivery_details_checked = [];
                pre_sort.products_without_delivery_details_checked = [];
                
                //loop through cart items to keep default settings
                element.forEach(function(item) {
                    //some settings
                    item.can_remove = true; //help in switching delete and not delete
                    item.display_delivery_details = false;

                    item.has_delivery = false; //reset
                    if(item.product_checked){
                        item.product_checked = false;
                    }
                    //check products with specific delivery details
                    service.getProductDeliveryOptions(this, item.product_main_id).then(response => { //recheck
                        if(response.body.status == 200) {
                            item.has_delivery = true;
                            item.delivery_option = 0;
                            pre_sort.products_with_delivery_details_count += 1;
                        }else{
                            pre_sort.products_without_delivery_details_count += 1;
                        }
                    }).catch((err) => {pre_sort.products_without_delivery_details_count += 1;})
                },this);
                pre_sort.display_delivery_details = 0;
                pre_sort[0] = element[0].product_business; 
                pre_sort[1] = element; //the cart items
                pre_sort.items_in_checkout = 0; // assign true if products are assigned to cart
                pre_sort.total_order_amt = 0.0 //assign shop total orders
                pre_sort.delivery_option_fee = 0.0 //asign delivery fee
                pre_sort.total_delivery_charge = 0.0 //including products individual delivery
                pre_sort.order_coupons_discounts = []; // for all selectedcoupons

                //promises hub
                let promises = [];
                for (let i = 0; i < 5; ++i) {
                    if(i == 1){
                        //check for available coupons
                        promises.push(
                            service.getBusinessDiscountsAndCoupons(this, element[0].product_business).then(response => { //recheck
                                if(response.body.status == 200) {
                                    pre_sort[4] = response.body.data;
                                }
                            }).catch((err) => {})
                        )
                    }
                    
                    if(i == 2){
                        //prep delivery options
                        promises.push(
                            service.getBusinessDeliveryOptions(this, element[0].product_business).then(response => { //recheck
                                if(response.body.status == 200){
                                    let delivery_options = response.body.data;
                                    //initially
                                    // pre_sort[2] = response.body.data;
                                    //../initially

                                    //updated
                                    //check if this business sorted cart has only one item and if that item has product id set
                                    //check element length
                                    if(element.length == 1){
                                        delivery_options.forEach(function(item) {
                                            let fees =  item.business_products_delivery_fees;
                                            //check first if has products delivery fee
                                            if(fees.length != 0){
                                                //loop through the product_delivery fees of each one
                                                fees.forEach(function(fee) {
                                                    //check if element has set product delivery fee
                                                    if(element[0].product_main_id == fee.product_delivery_product){
                                                        //attach has_product_delivery_fee
                                                        item.has_product_delivery_fee = true;
                                                        item.business_product_delivery_fee = fee.product_delivery_fee;
                                                        pre_sort[2] = delivery_options;
                                                    }
                                                },this)
                                            }else{
                                                pre_sort[2] = delivery_options;
                                            }
                                        },this)
                                    }else{
                                        pre_sort[2] = delivery_options; 
                                    }
                                    //--./updated

                                    //also updated ... business_shipping_calculation_method ../handle undefined errors later
                                    pre_sort.business_shipping_calculation_method = response.body.data_business_set_shipping_fee_status;

                                }else{
                                    pre_sort.delivery_option = "Free Delivery" //set by default
                                }
                                
                                // check pay on delivery
                                // service.checkBusinessPayOnDelivery(this, element[0].product_business).then(response => {
                                //     if(response.body.status == 200) {
                                //         pre_sort[3] = response.body.data;
                                //         sorted_cart_array.push(pre_sort);
                                //     }
                                // }).catch((err) => {})
                                // sorted_cart_array.push(pre_sort);
                            }).catch((err) => {})
                        )
                    }

                    if(i == 3){
                        // check pay on delivery
                        promises.push(
                            service.checkBusinessPayOnDelivery(this, element[0].product_business).then(response => {
                                if(response.body.status == 200) {
                                    pre_sort[3] = response.body.data;
                                    // sorted_cart_array.push(pre_sort);
                                }
                            }).catch((err) => {})
                        )
                    }
                }
               
                //process all promises
                Promise.all(promises)
                .then(() => {
                // for(i=0;i<promises.length;i++){
                        sorted_cart_array.push(pre_sort);   
                // }
                })
                .catch((e) => {
                    // handle errors here
                });
                //..promises hub
            }, this);
           
            
            this.sorted_cart = sorted_cart_array;
            

            return this.sorted_cart
           // return []
        },
       
        preset() {
            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            //this.checkout();
                            this.prepCart();
                        }, this);
                        this.loggedIn = true;
                    }else {
                        //this.$router.push('login');
                    }
                    this.loading = false;
                }).catch((err) => {
                    if(err) {
                    //this.$router.push('login');
                    //console.log(err)
                    }
                })
            }else {
            this.$router.push('login');
            }
        },

        //add or remove selected coupons
        set_coupons(i,coupon,coupon_percentage){
            let calc = 0;
            if(this.sorted_cart[i].total_order_amt != 0){ //check if a product from this group had been added to checkout 
                if(!coupon.added){ //not selected
                    //calc the percentage value with sellpoint current order amount
                    calc = ((coupon_percentage / 100) * this.sorted_cart[i].total_order_amt);
                   
                    // add to sellpoint used coupons
                    coupon.added = true; //set coupon
                    coupon.value = calc; //set coupon
                    this.sorted_cart[i].order_coupons_discounts.push(coupon);
    
                    // remove from sellpoint current order amount
                    this.sorted_cart[i].total_order_amt -= calc;
    
                    // remove from total current order price
                    this.total_order_amt -= calc;
                    
                }else{ //selected before
                    //get the coupon percentage valu
                    calc = coupon.value;
                   
                    // remove to sellpoint used coupons
                    coupon.added = false; //set coupon
                    const index = this.sorted_cart[i].order_coupons_discounts.findIndex(c => c.discount_id === coupon.discount_id) //best removal
                    this.sorted_cart[i].order_coupons_discounts.splice(index, 1);
    
                    // add to sellpoint current order amount
                    this.sorted_cart[i].total_order_amt += calc;
    
                    // add to total current order price
                    this.total_order_amt += calc;
                    coupon.value = 0; //reset coupon percentage value
                }
            }else{
                toastr.warning("Select an Order", 'Warning!');
                this.coupon_code.checked = false;
            }
        },

        // calc_delivery_fee(i,option,option_fee){
        //     //first check if already calculated delivery fee
        //     if(this.sorted_cart[i].delivery_option_fee != 0.0){
        //         this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee
        //     }
        //     this.sorted_cart[i].delivery_option = option;
        //     this.sorted_cart[i].delivery_option_fee = option_fee;
        //     //update delivery fee with new one
        //     this.total_delivery_fee += option_fee
        // }, // when radio button

        //for type of product(P) or sellpoint(SP)
        calc_product_delivery_fee(i,option,product_index){
           //first check if this product's delivery option has been added
            if(this.sorted_cart[i][1][product_index].delivery_option_fee != undefined){
                if(this.sorted_cart[i][1][product_index].delivery_option_fee != 0.0){
                    this.total_delivery_fee -= this.sorted_cart[i][1][product_index].delivery_option_fee
                    this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i][1][product_index].delivery_option_fee;
                }
            }

            this.sorted_cart[i][1][product_index].selected_product_delivery_option = option;//for display

            this.sorted_cart[i][1][product_index].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i][1][product_index].delivery_option_fee = Number(option.business_delivery_option_price);
            
            //update delivery fees with new one
            this.sorted_cart[i].total_delivery_charge += Number(option.business_delivery_option_price);
            this.total_delivery_fee += Number(option.business_delivery_option_price)
        },

        //sellpoint
        calc_sellpoint_delivery_fee_XXX(i,option){
            //first check if already calculated delivery fee and deduct
            if(this.sorted_cart[i].delivery_option_fee != 0.0){
                this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee
                this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i].delivery_option_fee;
            }
           
            this.sorted_cart[i].selected_business_delivery_option = option; //for display

            this.sorted_cart[i].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i].delivery_option_fee = Number(option.business_delivery_option_price);

            //cos product delivery may occur
            this.sorted_cart[i].total_delivery_charge += Number(option.business_delivery_option_price);
            //update delivery fee with new one
            this.total_delivery_fee += Number(option.business_delivery_option_price);

           
        },
        //NEW with independent delivery_option product delivery fee calculations and CONSTRAINTS inclusions
        calc_sellpoint_delivery_fee(i,option){
            //first check if already calculated delivery fee and deduct
            if(this.sorted_cart[i].delivery_option_fee != 0.0){
                this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee
                this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i].delivery_option_fee;
            }
            
            //display
            this.sorted_cart[i].selected_business_delivery_option = option; //for display
            //assign
            this.sorted_cart[i].delivery_option = option.business_delivery_option_id;

            //calculate

            //....b4.... this.sorted_cart[i].delivery_option_fee = Number(option.business_delivery_option_price);

            //...new--now
            this.sorted_cart[i].delivery_option_total_delivery_fee = 0;
            

            //check: if option does not have product delivery fees set
            let fees =  option.business_products_delivery_fees;
            if(fees.length == 0){
                //calculate delivery with Business Constraints
                if(this.sorted_cart[i].business_shipping_calculation_method == 9){ //one charge for all items ordered in this business
                    this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price)
                }else{
                    //constraints would affect/charge each item in this business
                    // filter get items of this business sorted cart that has been selected for checkout
                    let items_to_checkout = this.sorted_cart[i][1].filter(function(item){ return item.product_checked==true;});
                    for (let item of items_to_checkout) { 
                        if(this.sorted_cart[i].business_shipping_calculation_method == 10){ //charge each item
                            this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price)
                        }
                        if(this.sorted_cart[i].business_shipping_calculation_method == 11){ //charge each item and the quantities
                            this.sorted_cart[i].delivery_option_total_delivery_fee += Number(item.product_item_order_quantity * option.business_delivery_option_price)
                        }
                    }
                }
            }else{
                //option has product delivery fees set
                //so
                // filter get items of this business sorted cart that has been selected for checkout
                let items_to_checkout = this.sorted_cart[i][1].filter(function(item){ return item.product_checked==true;});

                //calculate for each item that has set delivery fee
                for (let item of items_to_checkout) { 
                    //some resets ... in situations wherby has been set by previous delivery options
                    if(item.has_calculated_product_delivery_fee == true)
                    {
                        item.has_calculated_product_delivery_fee = false;
                        item.calculated_product_delivery_fee = 0
                    };
                    //some resets../
                    //loop in fees
                    for (let fee of fees) { 
                        if(item.product_main_id == fee.product_delivery_product){ //product has shipping fee
                           //check product delivery fee calculation constraints
                           if(item.product_shipping_calculation_method == 13){ //shipping fee charges all product quantity ordered
                            this.sorted_cart[i].delivery_option_total_delivery_fee += Number(item.product_item_order_quantity * fee.product_delivery_fee)
                           }
                           if(item.product_shipping_calculation_method == 12){ //shipping fee does not charge product quantity ordered
                            this.sorted_cart[i].delivery_option_total_delivery_fee += Number(fee.product_delivery_fee);
                           }
                           //mark as calculated
                           item.has_calculated_product_delivery_fee = true;
                        }
                    }
                   
                }
                //restock sorted items
                // this.sorted_cart[i][1] = items;
                //.../..calculate for each item that has set delivery fee

                //then calculate for general sellpoint delivery option

                //check: if no of items with calculated product delivery fee for this option is == to the total no of items in this business cart
                let sorted_fees = items_to_checkout.filter(function(item){ return item.has_calculated_product_delivery_fee==true;});
                //if less than, more calculations to be made
                if(sorted_fees.length < items_to_checkout.length){ //more calculations to be made
                    //calculate delivery with Business Constraints
                    if(this.sorted_cart[i].business_shipping_calculation_method == 9){ //one charge for all items ordered in this business
                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price)
                    }else{
                        //constraints would affect/charge each item in this business
                        for (let item of items_to_checkout) { 
                            if(this.sorted_cart[i].business_shipping_calculation_method == 10){ //charge each item
                                this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price)
                            }
                            if(this.sorted_cart[i].business_shipping_calculation_method == 11){ //charge each item and the quantities
                                this.sorted_cart[i].delivery_option_total_delivery_fee += Number(item.product_item_order_quantity * option.business_delivery_option_price)
                            }
                        }
                    }
                }
                //end more calculations
            }
            

            //totalling
            this.sorted_cart[i].delivery_option_fee = Number(this.sorted_cart[i].delivery_option_total_delivery_fee);

            //cos product delivery may occur
            this.sorted_cart[i].total_delivery_charge += Number(this.sorted_cart[i].delivery_option_total_delivery_fee);
            //update delivery fee with new one
            this.total_delivery_fee += Number(this.sorted_cart[i].delivery_option_total_delivery_fee);
            //..totalling

            //../calculate
        },

       
        calc_total_delivery_fee(){
            this.sorted_cart.forEach(function(element) {
                //console.log(element['delivery_option_fee'])
                /////this.total_delivery_fee += element['delivery_option_fee']
            });
        },

        setPaymentOption(i,option){
            this.sorted_cart[i].payment_mode = option;
        },
    
        ///--=
        pre_checkout(){
            //check login
            this.preset();
        },

        //when quntity is increased or reduced
        refreshCheckout(it,group_index,item_index){
            this.sorted_cart[group_index].total_order_amt = 0;
            this.total_order_amt = 0;
            this.checked_out.forEach(function(item) {
                this.sorted_cart[group_index].total_order_amt += (item.product_item_order_quantity * item.product_item_price);
                //calculate general total order amount
                this.total_order_amt += (item.product_item_order_quantity * item.product_item_price);
            }, this);
        },
        
        addToCheckout(item,group_index,item_index){
            this.sorted_cart[group_index][1][item_index].can_remove = false; //disable remove item
            this.sorted_cart[group_index].products_in_checkout = true; //for this group checkout

            //for product delivery checks
            if(this.sorted_cart[group_index][1][item_index].has_delivery){
                this.sorted_cart[group_index].products_with_delivery_details_checked.push(item);
            }else{
                this.sorted_cart[group_index].products_without_delivery_details_checked.push(item);
            }

            this.checked_out.push(item);
            this.sorted_cart[group_index][1][item_index].product_checked = true; //[1] means the position of the items in a sellpoint as added in sorted_cart
            //caculate group store total order amount
            this.sorted_cart[group_index].total_order_amt += (item.product_item_order_quantity * item.product_item_price);
            //calculate general total order amount
            this.total_order_amt += (item.product_item_order_quantity * item.product_item_price);
            this.sorted_cart[group_index].items_in_checkout++;

            //some settings
            if(this.sorted_cart[group_index][1][item_index].has_delivery){
                this.sorted_cart[group_index][1][item_index].display_delivery_details = true; //show delivery details set for this item
            }

            //new ... recalculate sellpoint shipping fee if already selected
            if(this.sorted_cart[group_index].selected_business_delivery_option){
                this.calc_sellpoint_delivery_fee(group_index,this.sorted_cart[group_index].selected_business_delivery_option);
            }

            
            ///...for displaying totals and delivery options for buy_now_order
            if(this.buy_now_order){
                document.getElementById(item.item_index+"PRT_CART").style= "display:block;";
            }
        },
        
        removeFromCheckout(item,group_index,item_index){
            const index = this.checked_out.findIndex(p => p._id === item._id) //best removal
            this.checked_out.splice(index, 1);
            this.sorted_cart[group_index][1][item_index].product_checked = false;

            //for product delivery checks
            if(this.sorted_cart[group_index][1][item_index].has_delivery){
                const index = this.sorted_cart[group_index].products_with_delivery_details_checked.findIndex(p => p._id === item._id)
                this.sorted_cart[group_index].products_with_delivery_details_checked.splice(index, 1);;
            }else{
                const index =this.sorted_cart[group_index].products_without_delivery_details_checked.findIndex(p => p._id === item._id)
                this.sorted_cart[group_index].products_without_delivery_details_checked.splice(index, 1);;
            }

            //deduct group store total order amount
            this.sorted_cart[group_index].total_order_amt -= (item.product_item_order_quantity * item.product_item_price);
            //deduct general total order amount
            this.total_order_amt -= (item.product_item_order_quantity * item.product_item_price);
            this.sorted_cart[group_index].items_in_checkout--; //deduct

            this.sorted_cart[group_index][1][item_index].can_remove = true; //enable remove item

            //some checking to make sure shipping fee is reset when products are unchecked
            //and no products selected
            if((this.sorted_cart[group_index].items_in_checkout == 0) && (this.sorted_cart[group_index].delivery_option != "Free Delivery")){
                this.total_delivery_fee -= this.sorted_cart[group_index].delivery_option_fee; //reset
                this.sorted_cart[group_index].delivery_option_fee = 0; //reset
                this.sorted_cart[group_index].delivery_option = 0; //very funny - hard reset, cos some delivery option are strings eg. "Free delivery"
                this.sorted_cart[group_index].total_delivery_charge = 0; //reset
                
            }

            //new ... recalculate sellpoint shipping fee if already selected
            if(this.sorted_cart[group_index].selected_business_delivery_option){
                this.calc_sellpoint_delivery_fee(group_index,this.sorted_cart[group_index].selected_business_delivery_option);
            }
            
        },


        process_checkout(group){
            let processed_checkout = {};
            // if((group.delivery_option != 0) && (group.delivery_option != undefined)){
                processed_checkout.order_user_id = this.user.user_id;
                processed_checkout.order_mode = 1; //loggedIn
                processed_checkout.order_business = group[0];
                let order_url = group[0] + (new Date().getTime()); //set order url
                processed_checkout.order_url = order_url,
                processed_checkout.order_delivery_option = group.delivery_option;
                processed_checkout.order_payment_mode = group.payment_mode || 1; //default -pay now
                processed_checkout.order_coupons_discounts = group.order_coupons_discounts;
                processed_checkout.order_items = [];
                this.checked_out.forEach(function(element) { //groups
                    if(element.product_business == group[0]){//product_business
                        processed_checkout.order_items.push(element);
                    }
                    processed_checkout.status = "processed";
                }, this);
                if(processed_checkout.status == "processed"){
                    ///UPDATE -- process to save in localforage
                    if(this.loggedIn){
                        service.checkout(this,processed_checkout).then(function(data) {
                            if(data.body.status == 201) {
                                this.process_count++;
                                //remove from sorted cart and cart
                                processed_checkout.order_items.forEach(function(item) {
                                    this.$store.commit(REMOVE_FROM_CART, item._id); //remove from cart
                                    const index = this.checked_out.findIndex(p => p._id === item._id) //best removal
                                    this.checked_out.splice(index, 1);
                                    //remove from checkout, later find group id and remove from sorted cart
                                    // const index = this.sorted_cart[group_index][1].findIndex(p => p._id === item._id) //best removal
                                    // this.sorted_cart[group_index][1].splice(index, 1);
                                }, this);
                            // console.log(this.process_count)
                            }
                            // if(this.process_count == this.sorted_cart.length){
                            if(this.process_count == this.processed_groups){
                                this.total_delivery_fee = 0;
                                this.total_order_amt = 0;
                                //move to checkout page with particular order url
                                location.replace("/checkout/"+order_url)
                            }
                        }).catch((err) => {
                            if(err) {
                                toastr.warning("Something went wrong", 'Warning!'); 
                            // console.log(err) //possibly a load payment error
                            } 
                        })
                    }else{
                        //return to be saved in localforage
                        this.process_count++;
                        //remove from sorted cart and cart
                        processed_checkout.order_items.forEach(function(item) {
                            this.$store.commit(REMOVE_FROM_CART, item._id); //remove from cart
                            const index = this.checked_out.findIndex(p => p._id === item._id) //best removal
                            this.checked_out.splice(index, 1);
                        }, this);
                        
                        // if(this.process_count == this.sorted_cart.length){
                        if(this.process_count == this.processed_groups){
                            this.total_delivery_fee = 0;
                            this.total_order_amt = 0;
                            //return to be saved for checkout in localforage
                            return processed_checkout;
                        }
                    }
                    ///...///UPDATE -- process to save in localforage
                    
                }
        },

        
        process_orders(){
            let processed = [];
            let product_errors = 0;
            //prepare and validate process checkout
            this.checked_out.forEach(function(item) {
                if((item.has_delivery) && (item.delivery_option == 0)){ //check if item delivery is set
                    product_errors++;
                    toastr.error("Please select a delivery option for "+item.product_name, 'Warning!'); 
                }
            }, this);

            this.sorted_cart.forEach(function(group) {
                //check for only contain specific product with delivery
                let with_delivery = group.products_with_delivery_details_checked.length;
                let without_delivery = group.products_without_delivery_details_checked.length;
                
                if((with_delivery != 0) && (without_delivery == 0)){
                   group.delivery_option = "Product Specific Delivery Set";
                }

                if(group.items_in_checkout){ //check if has items in cart
                   if((group.delivery_option != 0) && (group.delivery_option != undefined)){
                        //check product with specific product details
                        processed.push(group);
                    }else{
                        product_errors++;
                        toastr.error("Please select a delivery option for "+group[0], 'Warning!'); 
                    }
                }
            }, this);


            ///UPDATE -- Don't process checkout except if user is logged instead save in localforage
            if(this.loggedIn){
                if((processed.length != 0) && (product_errors == 0)){
                    this.processed_groups = processed.length;
                    processed.forEach(function(group) {
                        this.process_checkout(group);
                    }, this);
                }
            }else{
                //save the whole processed in in local forage
                //localforage.setItem('buy_now_order', processed).then(function (value) { }).catch(function(err) {});
                //process and save
                let processed_to_store_in_forage = [];
                if((processed.length != 0) && (product_errors == 0)){
                    this.processed_groups = processed.length;
                    processed.forEach(function(group) {
                        processed_to_store_in_forage.push(this.process_checkout(group));
                    }, this);
                    localforage.setItem('buy_now_order', processed_to_store_in_forage).then(function (value) { }).catch(function(err) {});
                }
                //then push to checkout
                this.$router.push("checkout");
                // window.location.href = "checkout";
            }
        },

        // process_processed_orders(){
        //     let count = 0;
        //     if(this.processed_checkout_orders.length > 0){
        //         this.processed_checkout_orders.forEach(function(order) { 
        //             count++;
        //             //process checkout
        //             var payload = {
        //                 order_user_id: this.user.user_id,
        //                 order_business: order.order_business,
        //                 order_delivery_option: order.order_delivery_option,
        //                 order_payment_mode: order.order_payment_mode,
        //                 order_items: order.order_items
        //             }
        //             let wait_count = 0;

        //             service.checkout(this, payload).then(function(data) {
        //                 wait_count++;
        //                 if(data.body.status == 201) {
        //                     //remove from sorted cart and cart
        //                     // order.order_items.forEach(function(item) { 
        //                     //     console.log("rrr"+item._id)
        //                     //     this.removeFromSortedCart(item);
        //                     //     this.removeFromCart(item);
                                
        //                     // }, this);
        //                     //process payment
        //                 // this.processPayment(data.body.payment_data);
        //                     //move to checkout page
        //                     console.log(data.body.payment_data)
        //                 }
        //                 if(wait_count == this.processed_checkout_orders.length){
        //                     console.log("i very done")
        //                 }
        //             }).catch((err) => {
        //                 if(err) {
        //                 toastr.warning("Something went wrong", 'Warning!'); 
        //                 console.log(err) //possibly a load payment error
        //                 }
        //             })
        //         }, this);
        //     }
        //     console.log("i bh done")
        
        // },

    // process_orders(){
    //     console.log(this.checked_out)
    //     console.log(this.checked_out)
    //     this.checked_out.forEach(function(order) { 
    //         var payload = {
    //             order_user_id: this.user.user_id,
    //             order_business: order.product_business,
    //             order_delivery_option: order.order_delivery_option,
    //             order_payment_mode: order.order_payment_mode,
    //             order_items: order.order_items
    //         }
    //         console.log("here11")
    //         service.checkout(this, payload).then(function(data) {
    //             if(data.body.status == 201) {
    //                 //remove from sorted cart and cart
    //                 this.sorted_cart[group_i][1][item_i].check_out = true;

    //                 //process payment
    //                 //this.processPayment(data.body.payment_data);
    //                 //move to checkout page
    //                 console.log(data.body.payment_data)
    //             }
    //         }).catch((err) => {
    //             if(err) {
    //             toastr.warning("Something went wrong", 'Warning!'); 
    //             console.log(err) //possibly a load payment error
    //             }
    //         })
    //     }, this);
    // },


    // process_orders(){
    //     if(this.checked_out.length == 0){
    //         this.checked_out = this.cart;
    //     }
    //     var payload = {
    //         order_user_id: this.user.user_id,
    //         order_items: this.checked_out
    //       }
    //     service.checkout(this, payload).then(function(data) {
    //         if(data.body.status == 201) {
    //           //process payment
    //           this.processPayment(data.body.payment_data);
    //         }
    //     }).catch((err) => {
    //         if(err) {
    //           toastr.warning("Something went wrong", 'Warning!'); 
    //           console.log(err) //possibly a load payment error
    //         }
    //     })
    // },
    

     //connect to a payment gateway
     processPayment(data) {
      let obj = this;
      //this.amount_paid = data.plan_amount;
      var handler = PaystackPop.setup({
      key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
      Name: data.payment_payer_name,
      // email: data.plan_user_email || "admin@sellpoints.ng",
      email: "keneinfostream@gmail.com",
      amount:  (Math.round(data.payment_amount * 100)),//(data.plan_amount * 100), //in kobo
      ref: data.payment_ref,
      metadata: {
          custom_fields: [
              {
                  display_name: "",
                  variable_name: "",
                  value: data.payment_payer_name
              },
              {
                  display_name: "Service",
                  variable_name: "service_type",
                  value: data.payment_service
              }
              
          ]
      },
      
      callback: function(response){
          obj.updatePayment(response.trxref); 
          
      },
      onClose: function(){
          alert('window closed');
      }
      }); 
      handler.openIframe();
  },

  // update payments
  updatePayment(payment_ref) {

    var payload = {
       payment_order_ref: payment_ref,
       payment_user_id: this.user.user_id
   }
   let navi = this.$router;
   
   if(payment_ref != "") {
       service.updatePayment(this, payload).then(data => {
           if(data.body.status == 201) {
               toastr.success("Payment Processed!", "Success!");
               
               if(this.request_page != ''){
                   this.$router.push(this.request_page);
               }else {
                   this.$router.go('/');
               }
           }else {
               toastr.error('Sorry, could not update payment', 'Warning!');
           }
       }).catch((err) => {
           if(err) {
               toastr.error('Sorry, could not process information', 'Warning!');
           }
       })
    }else {
        toastr.error('Something went wrong', 'Warning!');
    }
    
  },

  },
  created(){
    if(this.$route.path == '/order'){
        this.buy_now_order = true;
    }
    document.title = "Cart" + " | SP";
    //this.preset();
    if((localStorage.getItem("sp_token")) != undefined){
        this.preset();
    }else{
        this.prepCart();
    }
    // this.prepCart();
  }
     
}


// WEBPACK FOOTER //
// ./src/pages/Buypoint/CartWidget/script.js